import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  EventEmitter, forwardRef,
  OnInit,
  Output,
  Renderer2, ViewContainerRef,
} from '@angular/core';
import { Component, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
@Component({
  selector: 'int-radio',
  templateUrl: 'int-radio.component.html',
  styleUrls: ['int-radio-vars.component.scss', 'int-radio.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IntRadioComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IntRadioComponent
  implements ControlValueAccessor, OnInit
{
  @Input() size = "md";
  @Input() disabled: boolean | null = false;
  @Input() checked = false;
  @Input() readonly = false;
  @Input() value: string | number = '';
  @Input() type: string = 'radio';
  @Input() name: string | null = null;
  @Input() controlValue: string | null = null;

  constructor(
    protected host: ViewContainerRef,
    protected renderer: Renderer2,
    private readonly cdr: ChangeDetectorRef
  ) { }

  get isChecked() {
    return `${this.controlValue}` === `${this.value}`
  }

  onChange(value: any) {
    //this.checked = `${this.value}` === `${value}`;
  }

  handleChange(value: Event): any {
    const _value = (value.target as any).value;
    this.onChange(_value);
  }

  onTouched() {}

  writeValue(value: any): void {
    this.onChange(value);
    this.cdr.markForCheck()
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  ngOnInit(): void {
    const element = this.host.element.nativeElement;
    const propsList = [
      this.size
    ];
    propsList.forEach((prop: string) => {
      this.renderer.addClass(element, prop);
    });
  }
}
